import Checkout from '../../../pages/Checkout';
import CreateBreakout from '../../../pages/CreateBreakout';
import CreatePeopleGroup from '../../../pages/CreatePeopleGroup';
import CreateInstantSurvey from '../../../pages/CreateInstantSurvey';
import CreateReport from '../../../pages/CreateReport';
import CreateTripGroup from '../../../pages/CreateTripGroup';
import Dashboards from '../../../pages/Dashboards';
import Narrative from '../../../pages/Narrative';
import Home from '../../../pages/Home';
import NarrativesRoute from '../../../pages/NarrativesChat/components/NarrativesRoute';
import Report from '../../../pages/Report';
import Reports from '../../../pages/Reports';
import Surveys from '../../../pages/Surveys';
import Survey from '../../../pages/Survey';
import User from '../../../pages/User';
import Workspace from '../../../pages/Workspace';

/**
 * gets first available route that is not locked
 * @param  {Object[]}  routes
 * @return {String} returns path of first available route
 */
export const getFirstAvailableRoute = (routes) => {
  return routes.find((route) => route?.is_locked !== true && route?.is_hidden !== true)?.path;
};

/**
 * gets component for route
 * @param {Object} route
 * @return {ReactNode}
 */
export const getRouteComponent = (route) => {
  switch (route.path) {
    case 'checkout':
      return <Checkout route={route} />;
    case 'create-breakout':
    case 'create-breakout/:custom_group_id':
      return <CreateBreakout />;
    case 'create-people-group':
      return <CreatePeopleGroup />;
    case 'create-report/:report':
      return <CreateReport />;
    case 'create-survey/:instant_survey_type_id':
      return <CreateInstantSurvey />;
    case 'create-trip-group':
      return <CreateTripGroup />;
    case 'dashboards':
      return <Dashboards route={route} />;
    case 'homepage':
      return <Home />;
    case 'narrative/:flow_id':
      return <Narrative />;
    case 'narratives':
      return <NarrativesRoute />;
    case 'report/:job_id':
    case 'report/:job_id/:tab_id':
      return <Report />;
    case 'reports':
      return <Reports route={route} />;
    case 'survey/:survey_id/*':
      return <Survey />;
    case 'user':
      return <User route={route} />;
    case 'verifiedvoices':
      return <Surveys route={route} />;
    case 'workspace':
      return <Workspace route={route} />;
    default:
      return null;
  }
};
